import { useEffect, useState } from 'react'
import { useAppSelector } from 'hooks'
import { readFileTxt } from 'utilities/helpers'

const TermContent: React.FC = () => {
  const { setting } = useAppSelector((s) => s.app)
  const [content, setContent] = useState('')
  useEffect(() => {
    readFileTxt(setting?.term_file_url, (value: string) => setContent(value))
  }, [setting?.term_file_url])
  return (
    <div className='term-content' dangerouslySetInnerHTML={{
      __html: content
    }}>
    </div>
  )
}

export default TermContent